import { getTypographyStyles, SEM_TYPOGRAPHY_FORMS_CAPTION, SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { Icon } from '../icon/index.js';
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
`;
export const StyledMessage = styled.span `
  color: ${(props) => props.variant === 'error'
    ? props.theme.sem.color.forms.foreground.text.error
    : props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
  display: flex;
  gap: ${SYS_SPACE_FIXED_50};
  align-items: top;
`;
//# sourceMappingURL=index.styles.js.map